import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import cn from 'classnames'
import _ from 'lodash'
import { navigate } from './constants'
import * as dateMath from 'date-arithmetic'
import html2canvas from 'html2canvas'
import { saveAs } from 'file-saver'
// import 'antd/lib/select/style/index.css'
// import 'antd/lib/grid/style/index.css'
// import 'antd/lib/style/index.less'
import Popover from 'antd/lib/popover'
import Modal from 'antd/lib/modal'
import Button from 'antd/lib/button'
// import 'antd/lib/popover/style/index.css'
import Calendar from 'antd/lib/calendar'
// import 'antd/lib/calendar/style/index.css'
import moment from 'moment'
import 'react-day-picker/lib/style.css'
import './css/style.css'
import './css/calendar-export.css'
import * as instructorActions from '../../_actions/roster.actions'
import * as leaveActions from '../../_actions/employeeLeave.actions'
import { CALENDAR_VIEWS } from './constants'
import { viewConstants } from '../../_constants/view.constants'

const NORMALWORKING_ACTION = 99

class WorkToolbar extends React.Component {
    static propTypes = {
        view: PropTypes.string.isRequired,
        views: PropTypes.arrayOf(PropTypes.string).isRequired,
        label: PropTypes.node.isRequired,
        localizer: PropTypes.object,
        onNavigate: PropTypes.func.isRequired,
        onView: PropTypes.func.isRequired,
    }

    state = {
        visible: false,
        displayLabel: '',
        current: moment(new Date()),
        isExporting: false,
        showPreviewModal: false,
        previewImageUrl: null,
    }

    handleVisibleChange = visible => {
        this.setState({ visible })
    }

    onSelect = date => {
        const selectedMoment = date

        this.setState({
            visible: false,
            current: selectedMoment,
        })

        const options = {
            range: viewConstants.WEEK,
            time: date.toDate() || new Date(),
        }

        if (!_.isEmpty(this.props.selectedEmployees)) {
            options.employees = this.props.selectedEmployees
        } else {
            options.employees = this.displayEmployeeIds()
        }

        this.props.actions.leaveActions.fetchEmployeeLeave(options)

        this.props.onNavigate(navigate.DATE, selectedMoment.toDate())

        this.getDatelable(selectedMoment)
    }

    getDatelable = date => {
        // Ant Design Calendar uses moment objects directly
        const selectedDate = date.format('DD/MM/YYYY')
        const dateLabel = `${selectedDate}`
        this.setState({ displayLabel: dateLabel })
    }

    getDatelableCurrent = () => {
        const now = moment(new Date())
        // const currentDate = now.format('DD/MM/YYYY')
        // const start = this.getFirstWeekDay(now)
        // const startLabel = `${start.format('DD/MM/YYYY')}`
        // const end = this.getLastWeekDay(now)
        // const lastLabel = `${end.format('DD/MM/YYYY')}`

        const currentDate = now.format('DD/MM/YYYY')

        const dateLabel = `${currentDate}`
        return dateLabel
    }

    getFirstWeekDay = date => {
        const firstDay = date.startOf('isoWeek')
        return firstDay
    }

    getLastWeekDay = date => {
        const lastDay = date.endOf('isoWeek')
        return lastDay
    }

    displayEmployeeIds = () => {
        const ids = this.props.displayEmployees.map(emp => {
            return emp.EmployeeAutoID
        })
        return ids
    }

    render() {
        let {
            localizer: { messages },
            label,
        } = this.props

        let { displayLabel } = this.state

        let popover = (
            <div className="popover-calendar">
                <Calendar fullscreen={false} onSelect={this.onSelect} />
            </div>
        )

        return (
            <div id="toolbar" className="rbc-toolbar">
                <span className="rbc-btn-group">
                    <button
                        type="button"
                        onClick={this.navigate.bind(null, navigate.PREVIOUS)}
                    >
                        <i className="fas fa-angle-double-left" />
                    </button>
                    <Popover
                        content={popover}
                        placement="bottom"
                        trigger="click"
                        open={this.state.visible}
                        onOpenChange={this.handleVisibleChange}
                    >
                        <button type="button">
                            {displayLabel == ''
                                ? this.getDatelableCurrent()
                                : displayLabel}
                        </button>
                    </Popover>
                    <button
                        type="button"
                        onClick={this.navigate.bind(null, navigate.NEXT)}
                    >
                        <i className="fas fa-angle-double-right" />
                    </button>
                </span>
                <span className="rbc-toolbar-label">{label}</span>

                <span className="rbc-btn-group">
                    {this.viewNamesGroup(messages)}
                    <button
                        type="button"
                        onClick={this.exportToPNG}
                        disabled={this.state.isExporting}
                        title="Export to PNG"
                        style={{
                            marginLeft: '10px',
                            cursor: this.state.isExporting ? 'wait' : 'pointer',
                        }}
                    >
                        {this.state.isExporting ? (
                            <i className="fas fa-spinner fa-spin" />
                        ) : (
                            <i className="fas fa-print" />
                        )}
                    </button>
                </span>

                <Modal
                    title="Calendar Preview"
                    open={this.state.showPreviewModal}
                    onCancel={this.handleClosePreview}
                    width="98vw"  // Use 98% of viewport width
                    centered
                    style={{ top: 0, paddingBottom: 0, margin: '10px auto' }}
                    styles={{ 
                        body: {
                            padding: '10px',
                            overflow: 'auto',  // Enable scrolling
                            maxHeight: 'calc(100vh - 120px)',
                            backgroundColor: '#f5f5f5'
                        }
                    }}
                    footer={[
                        <Button key="download" onClick={this.handleDownload}>
                            <i className="fas fa-download" style={{ marginRight: '8px' }} />
                            Download
                        </Button>,
                        <Button key="print" type="primary" onClick={this.handlePrint}>
                            <i className="fas fa-print" style={{ marginRight: '8px' }} />
                            Print
                        </Button>,
                        <Button key="close" onClick={this.handleClosePreview}>
                            Close
                        </Button>,
                    ]}
                >
                    {this.state.previewImageUrl && (
                        <img
                            src={this.state.previewImageUrl}
                            alt="Calendar Preview"
                            style={{ 
                                width: '100%', 
                                height: 'auto',
                                display: 'block',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                            }}
                        />
                    )}
                </Modal>
            </div>
        )
    }

    rangeChange = (date, action, view) => {
        switch (view) {
            case CALENDAR_VIEWS.WEEK:
                return this.navigateWeek(date, action)

            default:
                return date
        }
    }

    navigateWeek = (date, action) => {
        switch (action) {
            case navigate.PREVIOUS:
                return dateMath.add(date, -1, 'week')

            case navigate.NEXT:
                return dateMath.add(date, 1, 'week')
            case navigate.DATE:
                return date
            default:
                return date
        }
    }

    navigate = action => {
        const newDate = this.rangeChange(
            this.props.date,
            action,
            viewConstants.WEEK
        )

        if (navigate.PREVIOUS === action) {
            const previousWeek = this.state.current.subtract(1, 'week')
            this.setState({ current: previousWeek })
            this.getDatelable(previousWeek)
        } else if (navigate.NEXT === action) {
            const nextWeek = this.state.current.add(1, 'week')
            this.setState({ current: nextWeek })
            this.getDatelable(nextWeek)
        }

        const options = {
            range: viewConstants.WEEK,
            time: newDate || new Date(),
        }

        if (!_.isEmpty(this.props.selectedEmployees)) {
            options.employees = this.props.selectedEmployees
        } else {
            options.employees = this.displayEmployeeIds()
        }

        this.props.actions.leaveActions.fetchEmployeeLeave(options)

        this.props.onNavigate(action, this.props.date)
    }

    view = view => {
        this.props.onView(view)
    }

    handleClosePreview = () => {
        this.setState({
            showPreviewModal: false,
            previewImageUrl: null,
        })
    }

    handleDownload = () => {
        const { previewImageUrl } = this.state
        if (previewImageUrl) {
            const year = this.state.current.year()
            const week = this.state.current.isoWeek()
            const fileName = `leave-calendar-week-${year}-W${week}.png`
            
            // Convert data URL to blob and download
            fetch(previewImageUrl)
                .then(res => res.blob())
                .then(blob => {
                    saveAs(blob, fileName)
                })
        }
    }

    handlePrint = () => {
        const { previewImageUrl } = this.state
        if (previewImageUrl) {
            // Create a temporary container for the print image
            const printContainer = document.createElement('div')
            printContainer.id = 'print-calendar-container'
            printContainer.style.display = 'none'
            
            const img = document.createElement('img')
            img.src = previewImageUrl
            img.style.maxWidth = '100%'
            img.style.height = 'auto'
            
            printContainer.appendChild(img)
            document.body.appendChild(printContainer)
            
            // Add print-specific styles
            const style = document.createElement('style')
            style.id = 'print-calendar-styles'
            style.textContent = `
                @media print {
                    body > *:not(#print-calendar-container) {
                        display: none !important;
                    }
                    #print-calendar-container {
                        display: block !important;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: white;
                        z-index: 99999;
                    }
                    #print-calendar-container img {
                        max-width: 100%;
                        height: auto;
                        display: block;
                        margin: 0 auto;
                    }
                    @page {
                        margin: 0.5cm;
                    }
                }
            `
            document.head.appendChild(style)
            
            // Cleanup function
            const cleanup = () => {
                setTimeout(() => {
                    if (printContainer.parentNode) {
                        document.body.removeChild(printContainer)
                    }
                    if (style.parentNode) {
                        document.head.removeChild(style)
                    }
                }, 1000)
            }
            
            // Function to trigger print
            const triggerPrint = () => {
                setTimeout(() => {
                    window.print()
                    cleanup()
                }, 100)
            }
            
            // Wait for image to load, then print
            if (img.complete) {
                // Image is already loaded (cached)
                triggerPrint()
            } else {
                // Wait for image to load
                img.onload = triggerPrint
                img.onerror = cleanup // Cleanup on error too
            }
        }
    }

    exportToPNG = async () => {
        this.setState({ isExporting: true })

        try {
            // Find the calendar container
            const calendarElement = document.querySelector('.rbc-roster')
            
            if (!calendarElement) {
                console.error('Calendar element not found')
                this.setState({ isExporting: false })
                return
            }

                  // Store original styles
    const originalWidth = calendarElement.style.width;
    const originalMinWidth = calendarElement.style.minWidth;
    
    // Set larger width for export
    calendarElement.style.width = '1920px';  // or larger
    calendarElement.style.minWidth = '1920px';

        // Store original styles
    // const originalTransform = calendarElement.style.transform;
    // const originalTransformOrigin = calendarElement.style.transformOrigin;
    // const originalWidth = calendarElement.style.width;
    // const originalOverflow = calendarElement.style.overflow;
            
    //     // Apply scaling
    // calendarElement.style.transform = 'scale(2)';
    // calendarElement.style.transformOrigin = 'top left';
    // calendarElement.style.width = '960px'; // Half of 1920px since we're scaling 2x
    // calendarElement.style.overflow = 'visible';

            
            // Clear any text selections that might appear as lines
            if (window.getSelection) {
                window.getSelection().removeAllRanges()
            }
            
            // Add exporting class for CSS optimization
            calendarElement.classList.add('exporting')

            // Store original styles and adjust for export
            const dayCells = document.querySelectorAll('.rbc-day-cell')
            const originalCellStyles = Array.from(dayCells).map(cell => ({
                element: cell,
                minHeight: cell.style.minHeight,
                height: cell.style.height,
                overflow: cell.style.overflow,
            }))

            // Set minimum height and make overflow visible to show all events
            dayCells.forEach(cell => {
                cell.style.minHeight = '600px'
                cell.style.height = 'auto'
                cell.style.overflow = 'visible'
            })

            // Hide "+X more" links and show all events
            const showMoreLinks = document.querySelectorAll('.rbc-show-more')
            showMoreLinks.forEach(link => {
                link.style.display = 'none'
            })

            // Make all events visible
            const allEvents = document.querySelectorAll('.rbc-event')
            allEvents.forEach(event => {
                event.style.display = 'block'
                event.style.visibility = 'visible'
            })

            // Hide export button specifically
            const exportButton = document.querySelector('.rbc-toolbar button[title="Export to PNG"]')
            const exportButtonOriginalDisplay = exportButton ? exportButton.style.display : ''
            if (exportButton) {
                exportButton.style.display = 'none'
            }

            // Hide UI elements that shouldn't be in export
            const elementsToHide = document.querySelectorAll(
                '.ant-select, .p-button, .ant-collapse, .rosterToolBar'
            )
            const originalVisibility = Array.from(elementsToHide).map(el => ({
                element: el,
                visibility: el.style.visibility,
            }))
            elementsToHide.forEach(el => {
                el.style.visibility = 'hidden'
            })

            // Wait for layout to settle
            await new Promise(resolve => setTimeout(resolve, 300))

            // Capture the calendar
        //     const canvas = await html2canvas(calendarElement, {
        //         scale: 1, // Higher quality
        //         useCORS: true,
        //         logging: false,
        //         backgroundColor: '#ffffff',
        //                 width: 1920,
        // height: calendarElement.scrollHeight * 2
        // //         width: 1920,  // Fixed width
        // //         height: 1080, // Fixed height
        // //                 windowWidth: 1920,
        // // windowHeight: 1080
        //         // windowWidth: calendarElement.scrollWidth,
        //         // windowHeight: calendarElement.scrollHeight,
        //     })

            const canvas = await html2canvas(calendarElement, {
                            scale: 1, // Higher quality
                            useCORS: true,
                            logging: false,
                            backgroundColor: '#ffffff',
                            width: calendarElement.scrollWidth,
                            height: calendarElement.scrollHeight,
                            windowWidth: calendarElement.scrollWidth,
                            windowHeight: calendarElement.scrollHeight,
                            x: 0,
                            y: 0,
                            scrollY: -window.scrollY,
                            scrollX: -window.scrollX,
                        })

            // Restore original styles
            calendarElement.classList.remove('exporting')

            
                
    // Restore original styles
    calendarElement.style.width = originalWidth;
    calendarElement.style.minWidth = originalMinWidth;
        // Restore original styles
    // calendarElement.style.transform = originalTransform;
    // calendarElement.style.transformOrigin = originalTransformOrigin;
    // calendarElement.style.width = originalWidth;
    // calendarElement.style.overflow = originalOverflow;
            
            // Restore export button
            if (exportButton) {
                exportButton.style.display = exportButtonOriginalDisplay
            }
            
            originalCellStyles.forEach(({ element, minHeight, height, overflow }) => {
                element.style.minHeight = minHeight
                element.style.height = height
                element.style.overflow = overflow
            })
            showMoreLinks.forEach(link => {
                link.style.display = ''
            })
            originalVisibility.forEach(({ element, visibility }) => {
                element.style.visibility = visibility
            })

            // Convert canvas to data URL and show in modal
            const imageUrl = canvas.toDataURL('image/png')
            this.setState({ 
                isExporting: false,
                showPreviewModal: true,
                previewImageUrl: imageUrl,
            })
        } catch (error) {
            console.error('Error exporting calendar:', error)
            this.setState({ isExporting: false })
            alert('Failed to export calendar. Please try again.')
        }
    }

    viewNamesGroup(messages) {
        let viewNames = this.props.views
        const view = this.props.view

        if (viewNames.length > 1) {
            return viewNames.map(name => (
                <button
                    type="button"
                    key={name}
                    className={cn({ 'rbc-active': view === name })}
                    onClick={this.view.bind(null, name)}
                >
                    {messages[name]}
                </button>
            ))
        }
    }
}

function mapStateToProps(state) {
    return {
        displayEmployees: state.roster.displayEmployees,
        selectedEmployees: state.roster.selectedEmployees,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            rosterActions: bindActionCreators(instructorActions, dispatch),
            leaveActions: bindActionCreators(leaveActions, dispatch),
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkToolbar)
